'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _personal = require('redux/actions/personal');

var _payment = require('redux/actions/payment');

var _auth = require('redux/actions/auth');

var _basket = require('redux/actions/basket');

var _catalog = require('redux/actions/catalog');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _modal = require('redux/actions/modal');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _helpers = require('helpers');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _addresses = require('redux/actions/addresses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OrderDetail: {
        displayName: 'OrderDetail'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/OrderDetail/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OrderDetail = _wrapComponent('OrderDetail')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var _getState = getState(),
            user = _getState.auth.user;

        var promise = [];

        if (user) {
            var id = parseInt(params.order_id, 10);

            promise = [dispatch((0, _personal.getPersonalOrderDetail)(id)), dispatch((0, _payment.getPayment)()), dispatch((0, _auth.load)()), dispatch((0, _addresses.loadAddresses)())];
        }

        return _promise2.default.all([].concat((0, _toConsumableArray3.default)(promise), [dispatch((0, _personal.loadPage)(location))]));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        personal_order_detail: state.personal_order_detail,
        payments: state.payment.list,
        user: state.auth.user,
        setting: state.setting,
        lang: state.lang
    };
}, {
    getPayment: _payment.getPayment,
    getPersonalOrderDetail: _personal.getPersonalOrderDetail,
    setOrder: _personal.setOrder,
    pushState: _reactRouterRedux.push,
    addProduct: _basket.addProduct,
    getProduct: _catalog.getProduct,
    clearBasket: _basket.clearBasket,
    cancelOrder: _personal.cancelOrder,
    showModal: _modal.showModal,
    hide: _modal.hide,
    storage: _LocalStorageProxy2.default
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(OrderDetail, _Component);

    function OrderDetail(props) {
        (0, _classCallCheck3.default)(this, OrderDetail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (OrderDetail.__proto__ || (0, _getPrototypeOf2.default)(OrderDetail)).call(this, props));

        _this.onCancelOrder = function () {
            var lang = _this.props.lang;


            var modalContent = _react3.default.createElement(
                'div',
                { className: 'row no-margin' },
                _react3.default.createElement(
                    'div',
                    {
                        className: 'col-xs-12'
                    },
                    lang['store.cancelOrder.popup.confirmation']
                )
            );

            _this.props.showModal({
                title: lang['store.cancelOrder.popup.title'],
                content: modalContent,
                titleSuccess: lang['store.common.yes'],
                titleClose: lang['store.common.no'],
                onSuccess: function onSuccess() {
                    if (_this.props.personal_order_detail.order.paymentStatus != null) {
                        _this.props.personal_order_detail.order.paymentStatus.id = 8;
                        _this.setState({ is_cancel: true });
                    }
                    _this.props.cancelOrder(_this.props.personal_order_detail.order);
                },
                modalType: 'del'
            });
        };

        _this.editOrder = function () {
            _this.props.clearBasket();
            var product = null;
            var remainderQuantity = null;
            _LocalStorageProxy2.default.setItem('basket.edit_order_number', _this.props.personal_order_detail.order.order_number);
            _LocalStorageProxy2.default.setItem('basket.edit_order_id', _this.props.personal_order_detail.order.id);
            _this.props.personal_order_detail.order.products.forEach(function (productOrder, i) {
                product = null;
                remainderQuantity = null;
                _this.props.getProduct(productOrder.offer_id).then(function (result) {
                    product = result;
                    if (productOrder.modifier_option_id !== null && productOrder.modifiedOption.storable && product.type_id !== 5) {
                        product.modifier_option = result.modifiedOption.filter(function (value) {
                            return value.id === productOrder.modifier_option_id;
                        })[0];
                        remainderQuantity = product.modifier_option.remainder[0].quantity;
                        _this.props.addProduct({
                            description: product.description,
                            id: product.id,
                            name: product.name,
                            price: parseFloat(product.price),
                            picture: product.pictures ? product.pictures[0] : {},
                            count: productOrder.quantity,
                            type_id: product.type_id,
                            modifier_option_id: productOrder.modifier_option_id !== undefined ? productOrder.modifier_option_id : null,
                            modifier_option: productOrder.modifiedOption,
                            modifier_option_name: productOrder.modifier_option_name,
                            remainder_quantity: remainderQuantity
                        });
                    } else if (productOrder.modifier_option_id === null && product.storable && product.remainder[0] && product.type_id !== 5) {
                        if (product.storable) {
                            remainderQuantity = product.remainder[0].quantity;
                        }
                        _this.props.addProduct({
                            description: product.description,
                            id: product.id,
                            name: product.name,
                            price: parseFloat(product.price),
                            picture: product.pictures ? product.pictures[0] : {},
                            count: productOrder.quantity,
                            type_id: product.type_id,
                            modifier_option_id: productOrder.modifier_option_id !== undefined ? productOrder.modifier_option_id : null,
                            modifier_option: productOrder.modifiedOption !== undefined ? product.modifiedOption : null,
                            modifier_option_name: productOrder.modifier_option_name,
                            remainder_quantity: remainderQuantity
                        });
                    } else if (product.storable && product.remainder[0] && product.type_id === 5) {
                        var quantityTechCard = 1;
                        result.remainder = [];
                        var childOffers = [];
                        var childOffer = void 0;
                        var childOffersTwo = [];
                        var childOfferTwo = void 0;
                        var quantity = void 0;
                        result.nestedOffers.forEach(function (nestedOffer) {
                            productOrder.childProducts.forEach(function (actualNestedOffer) {
                                if (actualNestedOffer.offer_id === nestedOffer.childOffer.id) {
                                    nestedOffer.quantity = actualNestedOffer.quantity;
                                    nestedOffer.modifier_option_id = actualNestedOffer.modifier_option_id;
                                    nestedOffer.childOffer.modifierName = actualNestedOffer.modifier_option_name;
                                    nestedOffer.price = actualNestedOffer.price;
                                    if (nestedOffer.childOffer.type_id === 5) {
                                        nestedOffer.childOffer.remainder = [];
                                        nestedOffer.childOffer.storable = false;
                                        nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                                            actualNestedOffer.childProducts.forEach(function (actualNestedOfferTwo) {
                                                if (actualNestedOfferTwo.offer_id === nestedOfferTwo.childOffer.id) {
                                                    nestedOfferTwo.quantity = actualNestedOfferTwo.quantity;
                                                    nestedOfferTwo.modifier_option_id = actualNestedOfferTwo.modifier_option_id;
                                                    nestedOfferTwo.childOffer.modifierName = actualNestedOfferTwo.modifier_option_name;
                                                    nestedOfferTwo.price = actualNestedOfferTwo.price;
                                                }
                                            });
                                            _this.getRemainder(nestedOfferTwo, nestedOffer.quantity, result);
                                        });
                                    } else {
                                        _this.getRemainder(nestedOffer, quantityTechCard, result);
                                    }
                                }
                            });
                            // if (nestedOffer.quantity > 0) {
                            //     this.getRemainder(nestedOffer, quantityTechCard, result);
                            // }
                        });
                        remainderQuantity = result.remainder[0].quantity;
                        _this.props.addProduct({
                            description: product.description,
                            id: product.id,
                            name: product.name,
                            price: parseFloat(productOrder.price + productOrder.discount_sum / productOrder.quantit),
                            picture: product.pictures ? product.pictures[0] : {},
                            count: productOrder.quantity,
                            type_id: product.type_id,
                            modifier_option_id: productOrder.modifier_option_id !== undefined ? productOrder.modifier_option_id : null,
                            modifier_option: productOrder.modifiedOption !== undefined ? productOrder.modifiedOption : null,
                            remainder_quantity: remainderQuantity,
                            modifier_option_name: productOrder.modifier_option_name,
                            nested_offer: result.nestedOffers
                            // values_mods: product.valuesMods,
                        });
                    } else {
                        if (result.nestedOffers) {
                            result.nestedOffers.forEach(function (nestedOffer) {
                                productOrder.childProducts.forEach(function (actualNestedOffer) {
                                    if (actualNestedOffer.offer_id === nestedOffer.childOffer.id) {
                                        nestedOffer.quantity = actualNestedOffer.quantity;
                                        nestedOffer.modifier_option_id = actualNestedOffer.modifier_option_id;
                                        nestedOffer.childOffer.modifierName = actualNestedOffer.modifier_option_name;
                                        nestedOffer.price = actualNestedOffer.price;
                                        if (nestedOffer.childOffer.type_id === 5) {
                                            nestedOffer.childOffer.remainder = [];
                                            nestedOffer.childOffer.storable = false;
                                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                                                actualNestedOffer.childProducts.forEach(function (actualNestedOfferTwo) {
                                                    if (actualNestedOfferTwo.offer_id === nestedOfferTwo.childOffer.id) {
                                                        nestedOfferTwo.quantity = actualNestedOfferTwo.quantity;
                                                        nestedOfferTwo.modifier_option_id = actualNestedOfferTwo.modifier_option_id;
                                                        nestedOfferTwo.childOffer.modifierName = actualNestedOfferTwo.modifier_option_name;
                                                        nestedOfferTwo.price = actualNestedOfferTwo.price;
                                                    }
                                                });
                                            });
                                        }
                                    }
                                });
                            });
                        }
                        _this.props.addProduct({
                            description: product.description,
                            id: product.id,
                            name: product.name,
                            price: parseFloat(product.price),
                            picture: product.pictures ? product.pictures[0] : {},
                            count: productOrder.quantity,
                            type_id: product.type_id,
                            modifier_option_id: productOrder.modifier_option_id !== undefined ? productOrder.modifier_option_id : null,
                            modifier_option: productOrder.modifiedOption,
                            modifier_option_name: productOrder.modifier_option_name,
                            remainder_quantity: remainderQuantity,
                            nested_offer: result.nestedOffers
                        });
                    }
                    if (i === _this.props.personal_order_detail.order.products.length - 1) {
                        setTimeout(function () {
                            _this.props.pushState('/basket');
                        }, 500);
                    }
                });
            });
        };

        var location = props.location,
            params = props.params,
            personal_order_detail = props.personal_order_detail,
            pushState = props.pushState,
            user = props.user;
        var order_id = params.order_id;
        var query = location.query;


        if (!user) {
            if (!query.payment_in_id || !order_id) {
                pushState('/');
            }
        }

        var order = personal_order_detail.order || {};
        _this.state = {
            is_cancel: false
        };
        if (!order.id) {
            // если заказ не найден
            pushState('/personal/order-list'); // редиректим на "список заказов"
        }

        /**
         * Пока что, временно, данный функционал
         * относится только к сохранению адреса доставки
         */
        _this.onSaveOrder = function () {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref2$delivery_addres = _ref2.delivery_address,
                delivery_address = _ref2$delivery_addres === undefined ? null : _ref2$delivery_addres,
                _ref2$client_comment = _ref2.client_comment,
                client_comment = _ref2$client_comment === undefined ? null : _ref2$client_comment,
                _ref2$service_in_slug = _ref2.service_in_slug,
                service_in_slug = _ref2$service_in_slug === undefined ? null : _ref2$service_in_slug;

            _reactSAlert2.default.success(_this.props.lang['store.onSaveOrder.success'], { position: 'top-right', effect: 'slide', timeout: 7000 });
            _this.props.setOrder(order_id, client_comment, service_in_slug, delivery_address);
        };
        return _this;
    }

    (0, _createClass3.default)(OrderDetail, [{
        key: 'getRemainder',
        value: function getRemainder(nestedOffer, quantityParent, product_detail) {
            var _this2 = this;

            if (nestedOffer.childOffer === null) {
                return null;
            }
            if (nestedOffer.quantity > 0) {
                var quantity = void 0;
                var quantityTechCard = void 0;
                quantity = nestedOffer.quantity;
                if (nestedOffer.childOffer.modifier_option_id !== null && nestedOffer.childOffer.modOption === null) {
                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
                            return modifier;
                        }
                        return mod;
                    }, null);
                }
                if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
                    nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
                    if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.modOption.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
                                quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.modOption === null && nestedOffer.childOffer.type_id !== 5) {
                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
                            }
                            quantity = quantity * quantityParent;
                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
                if (nestedOffer.childOffer.type_id === 5) {
                    nestedOffer.childOffer.remainder = [];
                    nestedOffer.childOffer.storable = false;
                    quantity = nestedOffer.quantity * quantityParent;
                    nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                        _this2.getRemainder(nestedOfferTwo, quantity, product_detail);
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                order = _props.personal_order_detail.order,
                user = _props.user,
                payments = _props.payments,
                setting = _props.setting;

            var View = _helpers.ThemeHelper.getViewForContainer('OrderDetail', null, { folderName: 'Personal/OrderDetail' });

            if (order == null || user == null) {
                return null;
            }
            var helmetTitle = this.props.lang['store.common.order'] + ' № ' + order.order_number;
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
                _react3.default.createElement(View, {
                    onSaveOrder: this.onSaveOrder,
                    order: order,
                    payments: this.props.payments,
                    user: this.props.user,
                    setting: this.props.setting,
                    editOrder: this.editOrder,
                    cancelOrder: this.onCancelOrder,
                    isCancel: this.state.is_cancel
                })
            );
        }
    }]);
    return OrderDetail;
}(_react2.Component), _class2.propTypes = {
    getPayment: _react2.PropTypes.func.isRequired,
    getPersonalOrderDetail: _react2.PropTypes.func.isRequired,
    location: _react2.PropTypes.object.isRequired,
    params: _react2.PropTypes.object.isRequired,
    payments: _react2.PropTypes.array,
    personal_order_detail: _react2.PropTypes.object.isRequired,
    pushState: _react2.PropTypes.func.isRequired,
    user: _react2.PropTypes.object,
    setting: _react2.PropTypes.object.isRequired
}, _temp)) || _class) || _class));

exports.default = OrderDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/OrderDetail/index.jsx
// module id = 1830
// module chunks = 0